/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Whatsappphone1Inputs */

const en__field_whatsappphone1 = /** @type {(inputs: _Field_Whatsappphone1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whatsapp phonenumner`)
};

const de__field_whatsappphone1 = /** @type {(inputs: _Field_Whatsappphone1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whatsapp Telefonnummer`)
};

/**
* | output |
* | --- |
* | "Whatsapp phonenumner" |
*
* @param {_Field_Whatsappphone1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_whatsappphone1 = /** @type {((inputs?: _Field_Whatsappphone1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Whatsappphone1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_whatsappphone1(inputs)
	return de__field_whatsappphone1(inputs)
});
export { _field_whatsappphone1 as "_field_whatsappPhone" }